import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import {
    Funktionsbereich,
    FunktionsbereichAdminBenutzer,
    FunktionsbereichDetail,
    FunktionsbereichFreigabeRolle,
    Rolle,
    RolleDetail
} from '../../../clients/benutzerverwaltung';
import * as actionsUi from './funktionsbereiche-rollen.actions.ui';
import {AKTUELLE_MITTEILUNGS_VORLAGE_GESETZT, AKTUELLE_VORLAGE_EMPFAENGER_SETZEN, AKTUELLE_VORLAGE_TYPEN_SETZEN, AktuelleMitteilungsVorlageSetzenAction, AktuelleVorlageEmpfaengerSetzenAction, AktuelleVorlageTypenSetzenAction, NEUE_MITTEILUNGS_VORLAGE, NeuenFunktionsbereichAction, VORLAGE_BESCHREIBUNG_SETZEN, VORLAGE_TITEL_SETZEN, VorlageBeschreibungSetzenAction, VorlageTitelSetzenAction} from './funktionsbereiche-rollen.actions.ui';
import {
    GET_FUNKTIONSBEREICH_ADMINS,
    GET_FUNKTIONSBEREICH_ADMINS_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_ADMINS_FEHLER,
    GET_FUNKTIONSBEREICH_DETAIL,
    GET_FUNKTIONSBEREICH_DETAIL_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_DETAIL_FEHLER,
    GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN,
    GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN_FEHLER,
    GET_FUNKTIONSBEREICH_ROLLEN,
    GET_FUNKTIONSBEREICH_ROLLEN_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_ROLLEN_FEHLER,
    GET_FUNKTIONSBEREICHE,
    GET_FUNKTIONSBEREICHE_ERFOLGREICH,
    GET_FUNKTIONSBEREICHE_FEHLER,
    GET_ROLLE_DETAIL,
    GET_ROLLE_DETAIL_ERFOLGREICH,
    GET_ROLLE_DETAIL_FEHLER,
    GetFunktionsbereichAdminsErfolgreichAction,
    GetFunktionsbereichAdminsFehlerAction,
    GetFunktionsbereichDetailErfolgreichAction,
    GetFunktionsbereichDetailFehlerAction,
    GetFunktionsbereicheErfolgreichAction,
    GetFunktionsbereicheFehlerAction,
    GetFunktionsbereichFreigabeRollenErfolgreichAction,
    GetFunktionsbereichFreigabeRollenFehlerAction,
    GetFunktionsbereichRollenErfolgreichAction,
    GetFunktionsbereichRollenFehlerAction,
    GetRolleDetailErfolgreichAction,
    GetRolleDetailFehlerAction,
    POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_ERFOLGREICH,
    POST_FUNKTIONSBEREICH_LOESCHEN,
    POST_FUNKTIONSBEREICH_LOESCHEN_ERFOLGREICH,
    POST_ROLLE_LOESCHEN_ERFOLGREICH
} from '../../../client-ngrx/benutzerverwaltung';
import {
    GET_MITTEILUNGS_VORLAGE_DETAIL,
    GET_MITTEILUNGS_VORLAGE_DETAIL_ERFOLGREICH,
    GET_MITTEILUNGS_VORLAGE_DETAIL_FEHLER,
    GET_ROLLE_MITTEILUNG_OPTIONEN,
    GET_ROLLE_MITTEILUNG_OPTIONEN_ERFOLGREICH,
    GET_ROLLE_MITTEILUNG_OPTIONEN_FEHLER,
    GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE,
    GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE_ERFOLGREICH,
    GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE_FEHLER, GetMitteilungsVorlageDetailErfolgreichAction,
    GetRolleMitteilungOptionenErfolgreichAction,
    GetRolleMitteilungsVorlageListeErfolgreichAction, POST_MITTEILUNGS_VORLAGE_ANLEGEN_ERFOLGREICH, PostMitteilungsVorlageAnlegenAction
} from '../../../client-ngrx/kommunikation';
import {FunktionsbereichRolle, KommunikationRolleMitteilungOptionen, MitteilungsVorlage, MitteilungsVorlageDetail} from '../../../clients/kommunikation';
import {FunktionsbereichAbteilung, IncidentsRolleBerechtigung, RolleAbteilung, RolleZentrale} from '../../../clients/incidents';
import {
    GET_FUNKTIONSBEREICH_ABTEILUNG,
    GET_FUNKTIONSBEREICH_ABTEILUNG_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_ABTEILUNG_FEHLER, GET_INCIDENTS_ROLLE_BERECHTIGUNG, GET_INCIDENTS_ROLLE_BERECHTIGUNG_ERFOLGREICH, GET_INCIDENTS_ROLLE_BERECHTIGUNG_FEHLER,
    GET_ROLLE_ABTEILUNG, GET_ROLLE_ABTEILUNG_ERFOLGREICH, GET_ROLLE_ABTEILUNG_FEHLER,
    GET_ROLLE_ZENTRALE,
    GET_ROLLE_ZENTRALE_ERFOLGREICH,
    GET_ROLLE_ZENTRALE_FEHLER,
    GetFunktionsbereichAbteilungErfolgreichAction,
    GetFunktionsbereichAbteilungFehlerAction, GetIncidentsRolleBerechtigungErfolgreichAction, GetIncidentsRolleBerechtigungFehlerAction, GetRolleAbteilungErfolgreichAction, GetRolleAbteilungFehlerAction,
    GetRolleZentraleErfolgreichAction,
    GetRolleZentraleFehlerAction
} from '../../../client-ngrx/incidents';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {GET_EINLASSKONTROLLE_ROLLE, GET_EINLASSKONTROLLE_ROLLE_ERFOLGREICH, GET_EINLASSKONTROLLE_ROLLE_FEHLER, GetEinlasskontrolleRolleErfolgreichAction} from '../../../client-ngrx/einlasskontrolle';
import {GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG, GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG_ERFOLGREICH, GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG_FEHLER, GetDisplaysteuerungRolleBerechtigungErfolgreichAction} from '../../../client-ngrx/displaysteuerung';
import {DisplaysteuerungRolleBerechtigung} from '../../../clients/displaysteuerung';
import {EinlasskontrolleRolleBerechtigung} from '../../../clients/einlasskontrolle';
import {QsChecksRolleBerechtigung} from '../../../clients/qschecks';
import {GET_QS_CHECKS_ROLLE_BERECHTIGUNG, GET_QS_CHECKS_ROLLE_BERECHTIGUNG_ERFOLGREICH, GET_QS_CHECKS_ROLLE_BERECHTIGUNG_FEHLER, GetQsChecksRolleBerechtigungErfolgreichAction} from '../../../client-ngrx/qschecks';
import * as api from '../../../clients/kommunikation';
import {FunktionsbereichRollen} from '../../../clients/vorlagen';
import {VeranstaltungsTyp} from '../../../clients/veranstaltungstypen';
import {GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN, GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN_ERFOLGREICH, GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN_FEHLER, GetVeranstaltungBenutzerverwaltungRolleBerechtigungenErfolgreichAction} from '../../../client-ngrx/veranstaltungen';
import {BvRolleBerechtigung} from '../../../clients/veranstaltungen';

export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    funktionsbereichListe: Array<Funktionsbereich>;
    funktionsbereichListeUiLaden: boolean;
    funktionsbereichListeUiFehler: boolean;
    funktionsbereichListeUiFehlerObjekt: any;
    funktionsbereichListeUiSelektiert: Funktionsbereich;
    funktionsbereicheListeFilterString: string;

    funktionsbereichDetail: FunktionsbereichDetail;
    funktionsbereichDetailUiLaden: boolean;
    funktionsbereichDetailUiFehler: boolean;
    funktionsbereichDetailUiFehlerObjekt: any;

    funktionsbereichAdminBenutzerListe: Array<FunktionsbereichAdminBenutzer>;
    funktionsbereichAdminBenutzerListeUiLaden: boolean;
    funktionsbereichAdminBenutzerListeUiFehler: boolean;
    funktionsbereichAdminBenutzerListeUiFehlerObjekt: any;
    funktionsbereichAdminBenutzerListeUiSelektiert: FunktionsbereichAdminBenutzer;

    funktionsbereichFreigabeRolleListe: Array<FunktionsbereichFreigabeRolle>;
    funktionsbereichFreigabeRolleListeUiLaden: boolean;
    funktionsbereichFreigabeRolleListeUiFehler: boolean;
    funktionsbereichFreigabeRolleListeUiFehlerObjekt: any;
    funktionsbereichFreigabeRolleListeUiSelektiert: FunktionsbereichFreigabeRolle;

    funktionsbereichAbteilungsLeitstand: FunktionsbereichAbteilung;
    funktionsbereichAbteilungsLeitstandUiLaden: boolean;
    funktionsbereichAbteilungsLeitstandUiFehler: boolean;
    funktionsbereichAbteilungsLeitstandUiFehlerObjekt: any;

    rolleListe: Array<Rolle>;
    rolleListeUiLaden: boolean;
    rolleListeUiFehler: boolean;
    rolleListeUiFehlerObjekt: any;
    rolleListeUiSelektiert: Rolle;

    rolleDetail: RolleDetail;
    rolleDetailUiLaden: boolean;
    rolleDetailUiFehler: boolean;
    rolleDetailUiFehlerObjekt: any;

    rolleMitteilungOptionen: KommunikationRolleMitteilungOptionen;
    rolleMitteilungOptionenLaden: boolean;
    rolleMitteilungOptionenFehler: boolean;

    rolleZentralLeitstand: RolleZentrale;
    rolleZentralLeitstandUiLaden: boolean;
    rolleZentralLeitstandUiFehler: boolean;
    rolleZentralLeitstandUiFehlerObjekt: any;

    rolleAbteilungsLeitstand: RolleAbteilung;
    rolleAbteilungsLeitstandUiLaden: boolean;
    rolleAbteilungsLeitstandUiFehler: boolean;
    rolleAbteilungsLeitstandUiFehlerObjekt: any;

    rolleBerechtigung: IncidentsRolleBerechtigung;
    rolleBerechtigungUiLaden: boolean;
    rolleBerechtigungUiFehler: boolean;
    rolleBerechtigungUiFehlerObjekt: any;

    rolleMitteilungsVorlagen: Array<MitteilungsVorlage>;
    rolleMitteilungsVorlagenLaden: boolean;
    rolleMitteilungsVorlagenFehler: boolean;
    selectedRolleMitteilungsVorlage: MitteilungsVorlage;

    rolleMitteilungsVorlageDetail: MitteilungsVorlageDetail;
    rolleMitteilungsVorlageDetailLaden: boolean;
    rolleMitteilungsVorlageDetailFehler: boolean;

    selectedRolleMitteilungsVorlageEmpfaenger: Array<string>;
    selectedRolleMitteilungsVorlageTypen: Array<string>;

    tabUiSelektiert: string;

    einlasskontrolleRolle: EinlasskontrolleRolleBerechtigung;
    einlasskontrolleRolleLaden: boolean;
    einlasskontrolleRolleFehler: boolean;

    displaysteuerungRolle: DisplaysteuerungRolleBerechtigung;
    displaysteuerungRolleLaden: boolean;
    displaysteuerungRolleFehler: boolean;

    qsChecksRolle: QsChecksRolleBerechtigung;
    qsChecksRolleLaden: boolean;
    qsChecksRolleFehler: boolean;

    bvRolleBerechtigungen: BvRolleBerechtigung;
    bvRolleBerechtigungenLaden: boolean;
    bvRolleBerechtigungenFehler: boolean;
}

export const initialPageState: PageState = {
    funktionsbereichListe: [],
    funktionsbereichListeUiLaden: false,
    funktionsbereichListeUiFehler: false,
    funktionsbereichListeUiFehlerObjekt: null,
    funktionsbereichListeUiSelektiert: null,
    funktionsbereicheListeFilterString: '',

    funktionsbereichDetail: null,
    funktionsbereichDetailUiLaden: false,
    funktionsbereichDetailUiFehler: false,
    funktionsbereichDetailUiFehlerObjekt: null,

    funktionsbereichAdminBenutzerListe: [],
    funktionsbereichAdminBenutzerListeUiLaden: false,
    funktionsbereichAdminBenutzerListeUiFehler: false,
    funktionsbereichAdminBenutzerListeUiFehlerObjekt: null,
    funktionsbereichAdminBenutzerListeUiSelektiert: null,

    funktionsbereichFreigabeRolleListe: [],
    funktionsbereichFreigabeRolleListeUiLaden: false,
    funktionsbereichFreigabeRolleListeUiFehler: false,
    funktionsbereichFreigabeRolleListeUiFehlerObjekt: null,
    funktionsbereichFreigabeRolleListeUiSelektiert: null,

    funktionsbereichAbteilungsLeitstand: null,
    funktionsbereichAbteilungsLeitstandUiLaden: false,
    funktionsbereichAbteilungsLeitstandUiFehler: false,
    funktionsbereichAbteilungsLeitstandUiFehlerObjekt: null,

    rolleListe: [],
    rolleListeUiLaden: false,
    rolleListeUiFehler: false,
    rolleListeUiFehlerObjekt: null,
    rolleListeUiSelektiert: null,

    rolleDetail: null,
    rolleDetailUiLaden: false,
    rolleDetailUiFehler: false,
    rolleDetailUiFehlerObjekt: null,

    rolleMitteilungOptionen: null,
    rolleMitteilungOptionenLaden: false,
    rolleMitteilungOptionenFehler: false,

    rolleZentralLeitstand: null,
    rolleZentralLeitstandUiLaden: false,
    rolleZentralLeitstandUiFehler: false,
    rolleZentralLeitstandUiFehlerObjekt: null,

    rolleAbteilungsLeitstand: null,
    rolleAbteilungsLeitstandUiLaden: false,
    rolleAbteilungsLeitstandUiFehler: false,
    rolleAbteilungsLeitstandUiFehlerObjekt: null,

    rolleBerechtigung: null,
    rolleBerechtigungUiLaden: false,
    rolleBerechtigungUiFehler: false,
    rolleBerechtigungUiFehlerObjekt: null,

    rolleMitteilungsVorlagen: [],
    rolleMitteilungsVorlagenLaden: false,
    rolleMitteilungsVorlagenFehler: false,
    selectedRolleMitteilungsVorlage: null,

    rolleMitteilungsVorlageDetail: null,
    rolleMitteilungsVorlageDetailLaden: false,
    rolleMitteilungsVorlageDetailFehler: false,

    selectedRolleMitteilungsVorlageEmpfaenger: [],
    selectedRolleMitteilungsVorlageTypen: [],

    tabUiSelektiert: 'Kopfdaten',

    einlasskontrolleRolle: null,
    einlasskontrolleRolleLaden: false,
    einlasskontrolleRolleFehler: false,

    displaysteuerungRolle: null,
    displaysteuerungRolleLaden: false,
    displaysteuerungRolleFehler: false,

    qsChecksRolle: null,
    qsChecksRolleLaden: false,
    qsChecksRolleFehler: false,

    bvRolleBerechtigungen: null,
    bvRolleBerechtigungenLaden: false,
    bvRolleBerechtigungenFehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case actionsUi.FUNKTIONSBEREICH_SUCHEN: {
            const a = <actionsUi.FunktionsbereichSuchenAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheListeFilterString: a.filterString
            });
        }

        /* FUNKTIONSBEREICHE (LISTE) */
        case GET_FUNKTIONSBEREICHE: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichListeUiLaden: true,
                funktionsbereichListeUiFehler: false,
                funktionsbereichListeUiFehlerObjekt: null,
            });
        }

        case GET_FUNKTIONSBEREICHE_ERFOLGREICH: {
            const a = <GetFunktionsbereicheErfolgreichAction>action;

            if (state.funktionsbereichListeUiSelektiert !== null) {
                const index = a.payload.findIndex(x => x.funktionsbereich_id === state.funktionsbereichListeUiSelektiert.funktionsbereich_id);

                const funktionsbereichListeUiSelektiert = Object.assign({}, state.funktionsbereichListeUiSelektiert, a.payload[index]);

                return Object.assign({}, state, <PageState>{
                    funktionsbereichListe: a.payload,
                    funktionsbereichListeUiLaden: false,
                    funktionsbereichListeUiFehler: false,
                    funktionsbereichListeUiFehlerObjekt: null,
                    funktionsbereichListeUiSelektiert
                });

            } else {
                return Object.assign({}, state, <PageState>{
                    funktionsbereichListe: a.payload,
                    funktionsbereichListeUiLaden: false,
                    funktionsbereichListeUiFehler: false,
                    funktionsbereichListeUiFehlerObjekt: null
                });
            }
        }

        case GET_FUNKTIONSBEREICHE_FEHLER: {
            const a = <GetFunktionsbereicheFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichListe: [],
                funktionsbereichListeUiLaden: false,
                funktionsbereichListeUiFehler: true,
                funktionsbereichListeUiFehlerObjekt: a.payload
            });
        }

        /* FUNKTIONSBEREICH (DETAIL) */
        case GET_FUNKTIONSBEREICH_DETAIL: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichDetailUiLaden: true,
                funktionsbereichDetailUiFehler: false,
                funktionsbereichDetailUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_DETAIL_ERFOLGREICH: {
            const a = <GetFunktionsbereichDetailErfolgreichAction>action;

            if (state.funktionsbereichListeUiSelektiert && a.payload && state.funktionsbereichListeUiSelektiert.funktionsbereich_id === a.payload.funktionsbereich_id) {
                return Object.assign({}, state, <PageState>{
                    funktionsbereichDetail: a.payload,
                    funktionsbereichDetailUiLaden: false,
                    funktionsbereichDetailUiFehler: false,
                    funktionsbereichDetailUiFehlerObjekt: null
                });
            } else {
                return state;
            }
        }

        case GET_FUNKTIONSBEREICH_DETAIL_FEHLER: {
            const a = <GetFunktionsbereichDetailFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichDetail: null,
                funktionsbereichDetailUiLaden: false,
                funktionsbereichDetailUiFehler: true,
                funktionsbereichDetailUiFehlerObjekt: a.payload
            });
        }


        /* FUNKTIONSBEREICH ADMINS (LISTE) */
        case GET_FUNKTIONSBEREICH_ADMINS: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichAdminBenutzerListeUiLaden: true,
                funktionsbereichAdminBenutzerListeUiFehler: false,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_ADMINS_ERFOLGREICH: {
            const a = <GetFunktionsbereichAdminsErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                funktionsbereichAdminBenutzerListe: a.payload,
                funktionsbereichAdminBenutzerListeUiLaden: false,
                funktionsbereichAdminBenutzerListeUiFehler: false,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: null
            });

            if (state.funktionsbereichAdminBenutzerListeUiSelektiert != null && a.payload != null) {
                const aktuellSelektiert = a.payload.find(i => i.benutzer_id === state.funktionsbereichAdminBenutzerListeUiSelektiert.benutzer_id);
                if (aktuellSelektiert != null) {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichAdminBenutzerListeUiSelektiert: aktuellSelektiert
                    });
                } else {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichAdminBenutzerListeUiSelektiert: null
                    });
                }
            }

            return newState;
        }

        case GET_FUNKTIONSBEREICH_ADMINS_FEHLER: {
            const a = <GetFunktionsbereichAdminsFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichAdminBenutzerListe: [],
                funktionsbereichAdminBenutzerListeUiLaden: false,
                funktionsbereichAdminBenutzerListeUiFehler: true,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: a.payload
            });
        }



        /* FUNKTIONSBEREICH FREIGABE ROLLEN (LISTE) */
        case GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN: {
            return Object.assign({}, state, <PageState>{
                // funktionsbereichFreigabeRolleListe: [],
                funktionsbereichFreigabeRolleListeUiLaden: true,
                funktionsbereichFreigabeRolleListeUiFehler: false,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN_ERFOLGREICH: {
            const a = <GetFunktionsbereichFreigabeRollenErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                funktionsbereichFreigabeRolleListe: a.payload,
                funktionsbereichFreigabeRolleListeUiLaden: false,
                funktionsbereichFreigabeRolleListeUiFehler: false,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: null
            });

            if (state.funktionsbereichFreigabeRolleListeUiSelektiert != null && a.payload != null) {
                const aktuellSelektiert = a.payload.find(
                    i => i.rolle_id === state.funktionsbereichFreigabeRolleListeUiSelektiert.rolle_id);
                if (aktuellSelektiert != null) {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichFreigabeRolleListeUiSelektiert: aktuellSelektiert
                    });
                } else {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichFreigabeRolleListeUiSelektiert: null
                    });
                }
            }

            return newState;
        }

        case GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN_FEHLER: {
            const a = <GetFunktionsbereichFreigabeRollenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichFreigabeRolleListe: [],
                funktionsbereichFreigabeRolleListeUiLaden: false,
                funktionsbereichFreigabeRolleListeUiFehler: true,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: a.payload
            });
        }


        /* FUNKTIONSBEREICH ROLLEN (LISTE) */
        case GET_FUNKTIONSBEREICH_ROLLEN: {
            return Object.assign({}, state, <PageState>{
                // rolleListe: [],
                rolleListeUiLaden: true,
                rolleListeUiFehler: false,
                rolleListeUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_ROLLEN_ERFOLGREICH: {
            const a = <GetFunktionsbereichRollenErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                rolleListe: a.payload,
                rolleListeUiLaden: false,
                rolleListeUiFehler: false,
                rolleListeUiFehlerObjekt: null
            });

            if (state.rolleListeUiSelektiert != null && a.payload != null) {
                const aktuellSelektiert = a.payload.find(
                    i => i.rolle_id === state.rolleListeUiSelektiert.rolle_id);
                if (aktuellSelektiert != null) {
                    newState = Object.assign({}, newState, <PageState>{
                        rolleListeUiSelektiert: aktuellSelektiert
                    });
                } else {
                    newState = Object.assign({}, newState, <PageState>{
                        rolleListeUiSelektiert: null
                    });
                }
            }

            return newState;
        }

        case GET_FUNKTIONSBEREICH_ROLLEN_FEHLER: {
            const a = <GetFunktionsbereichRollenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleListe: [],
                rolleListeUiLaden: false,
                rolleListeUiFehler: true,
                rolleListeUiFehlerObjekt: a.payload
            });
        }

        /* FUNKTIONSBEREICH ABTEILUNGS-LEITSTAND */
        case GET_FUNKTIONSBEREICH_ABTEILUNG: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichAbteilungsLeitstand: null,
                funktionsbereichAbteilungsLeitstandUiLaden: true,
                funktionsbereichAbteilungsLeitstandUiFehler: false,
                funktionsbereichAbteilungsLeitstandUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_ABTEILUNG_ERFOLGREICH: {
            const a = <GetFunktionsbereichAbteilungErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                funktionsbereichAbteilungsLeitstand: a.payload,
                funktionsbereichAbteilungsLeitstandUiLaden: false,
                funktionsbereichAbteilungsLeitstandUiFehler: false,
                funktionsbereichAbteilungsLeitstandUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICH_ABTEILUNG_FEHLER: {
            const a = <GetFunktionsbereichAbteilungFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichAbteilungsLeitstand: null,
                funktionsbereichAbteilungsLeitstandUiLaden: false,
                funktionsbereichAbteilungsLeitstandUiFehler: true,
                funktionsbereichAbteilungsLeitstandUiFehlerObjekt: a.payload
            });
        }

        /* FUNKTIONSBEREICH ROLLEN (DETAIL) */
        case GET_ROLLE_DETAIL: {
            return Object.assign({}, state, <PageState>{
                // rolleDetail: {},
                rolleDetailUiLaden: true,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null
            });
        }

        case GET_ROLLE_DETAIL_ERFOLGREICH: {
            const a = <GetRolleDetailErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleDetail: a.payload,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null
            });
        }

        case GET_ROLLE_DETAIL_FEHLER: {
            const a = <GetRolleDetailFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleDetail: null,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: true,
                rolleDetailUiFehlerObjekt: a.payload
            });
        }

        // Rolle Mitteilung Optionen
        case GET_ROLLE_MITTEILUNG_OPTIONEN: {
            return Object.assign({}, state, <PageState>{
                rolleMitteilungOptionenLaden: true,
                rolleMitteilungOptionenFehler: false
            });
        }

        case GET_ROLLE_MITTEILUNG_OPTIONEN_ERFOLGREICH: {
            const a = <GetRolleMitteilungOptionenErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleMitteilungOptionen: a.payload,
                rolleMitteilungOptionenLaden: false,
                rolleMitteilungOptionenFehler: false
            });
        }

        case GET_ROLLE_MITTEILUNG_OPTIONEN_FEHLER: {
            const a = <GetRolleDetailFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleMitteilungOptionen: null,
                rolleMitteilungOptionenLaden: false,
                rolleMitteilungOptionenFehler: true
            });
        }

        // Rolle Zentral Leitstand
        case GET_ROLLE_ZENTRALE: {
            return Object.assign({}, state, <PageState>{
                rolleZentralLeitstandUiLaden: true,
                rolleZentralLeitstandUiFehler: false,
                rolleZentralLeitstandUiFehlerObjekt: null
            });
        }

        case GET_ROLLE_ZENTRALE_ERFOLGREICH: {
            const a = <GetRolleZentraleErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleZentralLeitstand: a.payload,
                rolleZentralLeitstandUiLaden: false,
                rolleZentralLeitstandUiFehler: false
            });
        }

        case GET_ROLLE_ZENTRALE_FEHLER: {
            const a = <GetRolleZentraleFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleZentralLeitstand: null,
                rolleZentralLeitstandUiLaden: false,
                rolleZentralLeitstandUiFehler: true,
                rolleZentralLeitstandUiFehlerObjekt: a.payload
            });
        }

        // Rolle Abteilungs Leitstand
        case GET_ROLLE_ABTEILUNG: {
            return Object.assign({}, state, <PageState>{
                rolleAbteilungsLeitstandUiLaden: true,
                rolleAbteilungsLeitstandUiFehler: false,
                rolleAbteilungsLeitstandUiFehlerObjekt: null
            });
        }

        case GET_ROLLE_ABTEILUNG_ERFOLGREICH: {
            const a = <GetRolleAbteilungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleAbteilungsLeitstand: a.payload,
                rolleAbteilungsLeitstandUiLaden: false,
                rolleAbteilungsLeitstandUiFehler: false
            });
        }

        case GET_ROLLE_ABTEILUNG_FEHLER: {
            const a = <GetRolleAbteilungFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleAbteilungsLeitstand: null,
                rolleAbteilungsLeitstandUiLaden: false,
                rolleAbteilungsLeitstandUiFehler: true,
                rolleAbteilungsLeitstandUiFehlerObjekt: a.payload
            });
        }

        // Rolle Berechtigung
        case GET_INCIDENTS_ROLLE_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                rolleBerechtigungUiLaden: true,
                rolleBerechtigungUiFehler: false,
                rolleBerechtigungUiFehlerObjekt: null
            });
        }

        case GET_INCIDENTS_ROLLE_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetIncidentsRolleBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleBerechtigung: a.payload,
                rolleBerechtigungUiLaden: false,
                rolleBerechtigungUiFehler: false
            });
        }

        case GET_INCIDENTS_ROLLE_BERECHTIGUNG_FEHLER: {
            const a = <GetIncidentsRolleBerechtigungFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleBerechtigung: null,
                rolleBerechtigungUiLaden: false,
                rolleBerechtigungUiFehler: true,
                rolleBerechtigungUiFehlerObjekt: a.payload
            });
        }

        // Rolle Mitteilungs Vorlage Liste
        case GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE: {
            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlagenLaden: true,
                rolleMitteilungsVorlagenFehler: false,
            });
        }

        case GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE_ERFOLGREICH: {
            const a = <GetRolleMitteilungsVorlageListeErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlagen: a.payload,
                rolleMitteilungsVorlagenLaden: false,
                rolleMitteilungsVorlagenFehler: false
            });
        }

        case GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlagen: [],
                rolleMitteilungsVorlagenLaden: false,
                rolleMitteilungsVorlagenFehler: true
            });
        }

        case AKTUELLE_MITTEILUNGS_VORLAGE_GESETZT: {
            const a = <AktuelleMitteilungsVorlageSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                selectedRolleMitteilungsVorlage: a.payload
            });
        }

        case NEUE_MITTEILUNGS_VORLAGE: {
            const rolleMitteilungsVorlageDetail: MitteilungsVorlageDetail = {
               beschreibung: '',
               empfaenger_rolle_liste: [],
               mandant_id: state.funktionsbereichDetail.mandant_id,
               mitteilungs_vorlage_id: null,
               rolle_id: state.rolleDetail.rolle_id,
               titel: '',
               veranstaltungstyp_liste: []
            };

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail
            });
        }

        case AKTUELLE_VORLAGE_EMPFAENGER_SETZEN: {
            const a = <AktuelleVorlageEmpfaengerSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                selectedRolleMitteilungsVorlageEmpfaenger: a.payload
            });
        }

        case AKTUELLE_VORLAGE_TYPEN_SETZEN: {
            const a = <AktuelleVorlageTypenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                selectedRolleMitteilungsVorlageTypen: a.payload
            });
        }

        case VORLAGE_TITEL_SETZEN: {
            const a = <VorlageTitelSetzenAction>action;

            const rolleMitteilungsVorlageDetail = Object.assign({}, state.rolleMitteilungsVorlageDetail, <MitteilungsVorlageDetail>{
                titel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail
            });
        }

        case VORLAGE_BESCHREIBUNG_SETZEN: {
            const a = <VorlageBeschreibungSetzenAction>action;

            const rolleMitteilungsVorlageDetail = Object.assign({}, state.rolleMitteilungsVorlageDetail, <MitteilungsVorlageDetail>{
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail
            });
        }

        // Rolle Mitteilungs Vorlage Detail
        case GET_MITTEILUNGS_VORLAGE_DETAIL: {
            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetailLaden: true,
                rolleMitteilungsVorlageDetailFehler: false,
            });
        }

        case GET_MITTEILUNGS_VORLAGE_DETAIL_ERFOLGREICH: {
            const a = <GetMitteilungsVorlageDetailErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail: a.payload,
                rolleMitteilungsVorlageDetailLaden: false,
                rolleMitteilungsVorlageDetailFehler: false
            });
        }

        case GET_MITTEILUNGS_VORLAGE_DETAIL_FEHLER: {
            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail: null,
                rolleMitteilungsVorlageDetailLaden: false,
                rolleMitteilungsVorlageDetailFehler: true
            });
        }

        case POST_MITTEILUNGS_VORLAGE_ANLEGEN_ERFOLGREICH: {
            const a = <PostMitteilungsVorlageAnlegenAction>action;

            const rolleMitteilungsVorlageDetail = Object.assign({}, state.rolleMitteilungsVorlageDetail, <MitteilungsVorlageDetail> {
                mitteilungs_vorlage_id: a.mitteilungsVorlageDatenRequest.mitteilungs_vorlage_id
            });

            const selectedRolleMitteilungsVorlage = Object.assign({}, state.selectedRolleMitteilungsVorlage, <MitteilungsVorlage> {
                mitteilungs_vorlage_id: a.mitteilungsVorlageDatenRequest.mitteilungs_vorlage_id,
                beschreibung: a.mitteilungsVorlageDatenRequest.beschreibung,
                titel: a.mitteilungsVorlageDatenRequest.titel,
                rolle_id: a.mitteilungsVorlageDatenRequest.rolle_id
            });

            return Object.assign({}, state, <PageState>{
                rolleMitteilungsVorlageDetail,
                selectedRolleMitteilungsVorlage
            });
        }


        // Rolle Einlasskontrolle
        case GET_EINLASSKONTROLLE_ROLLE: {
            return Object.assign({}, state, <PageState>{
                einlasskontrolleRolleLaden: true,
                einlasskontrolleRolleFehler: false
            });
        }

        case GET_EINLASSKONTROLLE_ROLLE_ERFOLGREICH: {
            const a = <GetEinlasskontrolleRolleErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                einlasskontrolleRolle: a.payload,
                einlasskontrolleRolleLaden: false,
                einlasskontrolleRolleFehler: false
            });
        }

        case GET_EINLASSKONTROLLE_ROLLE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                einlasskontrolleRolle: null,
                einlasskontrolleRolleLaden: false,
                einlasskontrolleRolleFehler: true
            });
        }

        // Rolle Displaysteuerung
        case GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                displaysteuerungRolleLaden: true,
                displaysteuerungRolleFehler: false
            });
        }

        case GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetDisplaysteuerungRolleBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                displaysteuerungRolle: a.payload,
                displaysteuerungRolleLaden: false,
                displaysteuerungRolleFehler: false
            });
        }

        case GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG_FEHLER: {
            return Object.assign({}, state, <PageState>{
                displaysteuerungRolle: null,
                displaysteuerungRolleLaden: false,
                displaysteuerungRolleFehler: true
            });
        }

        // Rolle QS Checks
        case GET_QS_CHECKS_ROLLE_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                qsChecksRolleLaden: true,
                qsChecksRolleFehler: false
            });
        }

        case GET_QS_CHECKS_ROLLE_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetQsChecksRolleBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                qsChecksRolle: a.payload,
                qsChecksRolleLaden: false,
                qsChecksRolleFehler: false
            });
        }

        case GET_QS_CHECKS_ROLLE_BERECHTIGUNG_FEHLER: {
            return Object.assign({}, state, <PageState>{
                qsChecksRolle: null,
                qsChecksRolleLaden: false,
                qsChecksRolleFehler: true
            });
        }

        // Benutzerverwaltung Rolle Berechtigungen
        case GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN: {
            return Object.assign({}, state, <PageState>{
                bvRolleBerechtigungenLaden: true,
                bvRolleBerechtigungenFehler: false
            });
        }

        case GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN_ERFOLGREICH: {
            const a = <GetVeranstaltungBenutzerverwaltungRolleBerechtigungenErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                bvRolleBerechtigungen: a.payload,
                bvRolleBerechtigungenLaden: false,
                bvRolleBerechtigungenFehler: false
            });
        }

        case GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                bvRolleBerechtigungen: null,
                bvRolleBerechtigungenLaden: false,
                bvRolleBerechtigungenFehler: true
            });
        }

        /* BENUTZERVERWALTUNG COMMANDS */
        case POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichAdminBenutzerListeUiSelektiert: null
            });
        }

        case POST_FUNKTIONSBEREICH_LOESCHEN: {
            return Object.assign({}, state, <PageState>{
                // uiZeigeDetailbereichLadeanimation: true,
                // uiZeigeDetailbereich: false
            });
        }

        case POST_FUNKTIONSBEREICH_LOESCHEN_ERFOLGREICH: {
            return Object.assign({}, state, initialPageState);
        }

        case POST_ROLLE_LOESCHEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                rolleDetail: null,
                rolleListeUiSelektiert: null
                // uiAktuelleRolle: null,
                // uiZeigeRolleDetailbereich: false
            });
        }

        case actionsUi.AKTUELLER_FUNKTIONSBEREICH_WURDE_GELOESCHT: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichListeUiLaden: false,
                funktionsbereichListeUiFehler: false,
                funktionsbereichListeUiFehlerObjekt: null,
                funktionsbereichListeUiSelektiert: null,

                funktionsbereichDetail: null,
                funktionsbereichDetailUiLaden: false,
                funktionsbereichDetailUiFehler: false,
                funktionsbereichDetailUiFehlerObjekt: null,

                funktionsbereichAdminBenutzerListe: [],
                funktionsbereichAdminBenutzerListeUiLaden: false,
                funktionsbereichAdminBenutzerListeUiFehler: false,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: null,
                funktionsbereichAdminBenutzerListeUiSelektiert: null,

                funktionsbereichFreigabeRolleListe: [],
                funktionsbereichFreigabeRolleListeUiLaden: false,
                funktionsbereichFreigabeRolleListeUiFehler: false,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: null,
                funktionsbereichFreigabeRolleListeUiSelektiert: null,

                rolleListe: [],
                rolleListeUiLaden: false,
                rolleListeUiFehler: false,
                rolleListeUiFehlerObjekt: null,
                rolleListeUiSelektiert: null,

                rolleDetail: null,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null,

                tabUiSelektiert: 'Kopfdaten'
            });
        }

        case actionsUi.AKTUELLE_ROLLE_WURDE_GELOESCHT: {
            return Object.assign({}, state, <PageState>{
                rolleListeUiSelektiert: null,

                rolleDetail: null,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null
            });
        }

        /* UI */
        case actionsUi.NEUEN_FUNKTIONSBEREICH: {
            const a = <NeuenFunktionsbereichAction>action;
            return Object.assign({}, state, <PageState>{
                funktionsbereichListeUiLaden: false,
                funktionsbereichListeUiFehler: false,
                funktionsbereichListeUiFehlerObjekt: null,
                funktionsbereichListeUiSelektiert: a.funktionsbereichDetail,

                funktionsbereichDetail: a.funktionsbereichDetail,
                funktionsbereichDetailUiLaden: false,
                funktionsbereichDetailUiFehler: false,
                funktionsbereichDetailUiFehlerObjekt: null,

                funktionsbereichAdminBenutzerListe: [],
                funktionsbereichAdminBenutzerListeUiLaden: false,
                funktionsbereichAdminBenutzerListeUiFehler: false,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: null,
                funktionsbereichAdminBenutzerListeUiSelektiert: null,

                funktionsbereichFreigabeRolleListe: [],
                funktionsbereichFreigabeRolleListeUiLaden: false,
                funktionsbereichFreigabeRolleListeUiFehler: false,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: null,
                funktionsbereichFreigabeRolleListeUiSelektiert: null,

                rolleMitteilungOptionen: null,
                rolleMitteilungOptionenLaden: false,
                rolleMitteilungOptionenFehler: false,

                rolleListe: [],
                rolleListeUiLaden: false,
                rolleListeUiFehler: false,
                rolleListeUiFehlerObjekt: null,
                rolleListeUiSelektiert: null,

                rolleDetail: null,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null,

                tabUiSelektiert: 'Kopfdaten'
            });
        }

        case actionsUi.NEUEN_FUNKTIONSBEREICH_ABBRECHEN: {
            return Object.assign({}, state, <PageState>{
                funktionsbereichDetail: null
            });
        }

        case actionsUi.NEUE_ROLLE: {
            return Object.assign({}, state, <PageState>{
                rolleDetail: {},
                rolleMitteilungOptionen: {}
            });
        }

        case actionsUi.NEUE_ROLLE_ABBRECHEN: {
            return Object.assign({}, state, <PageState>{
                rolleDetail: null,
                rolleMitteilungOptionen: null
            });
        }


        case actionsUi.AKTUELLE_ROLLE_GESETZT: {
            const a = <actionsUi.AktuelleRolleSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                rolleListeUiSelektiert: a.rolle,
                rolleMitteilungsVorlageDetail: null,
                selectedRolleMitteilungsVorlage: null
            });
        }


        case actionsUi.AKTUELLEN_FUNKTIONSBEREICHS_ADMIN_GESETZT: {
            const a = <actionsUi.AktuellenFunktionsbereichsAdminSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichAdminBenutzerListeUiSelektiert: a.funktionsbereichAdminBenutzer
            });
        }

        case actionsUi.AKTUELLEN_FUNKTIONSBEREICHS_FREIGABE_ROLLE_GESETZT: {
            const a = <actionsUi.AktuellenFunktionsbereichsFreigabeRolleSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichFreigabeRolleListeUiSelektiert: a.funktionsbereichFreigabeRolle
            });
        }

        case actionsUi.AKTUELLEN_FUNKTIONSBEREICH_GESETZT: {
            const a = <actionsUi.AktuellenFunktionsbereichSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereichListeUiLaden: false,
                funktionsbereichListeUiFehler: false,
                funktionsbereichListeUiFehlerObjekt: null,
                funktionsbereichListeUiSelektiert: a.funktionsbereich,

                funktionsbereichDetail: null,
                funktionsbereichDetailUiLaden: false,
                funktionsbereichDetailUiFehler: false,
                funktionsbereichDetailUiFehlerObjekt: null,

                funktionsbereichAdminBenutzerListe: [],
                funktionsbereichAdminBenutzerListeUiLaden: false,
                funktionsbereichAdminBenutzerListeUiFehler: false,
                funktionsbereichAdminBenutzerListeUiFehlerObjekt: null,
                funktionsbereichAdminBenutzerListeUiSelektiert: null,

                funktionsbereichFreigabeRolleListe: [],
                funktionsbereichFreigabeRolleListeUiLaden: false,
                funktionsbereichFreigabeRolleListeUiFehler: false,
                funktionsbereichFreigabeRolleListeUiFehlerObjekt: null,
                funktionsbereichFreigabeRolleListeUiSelektiert: null,

                rolleListe: [],
                rolleListeUiLaden: false,
                rolleListeUiFehler: false,
                rolleListeUiFehlerObjekt: null,
                rolleListeUiSelektiert: null,

                rolleDetail: null,
                rolleDetailUiLaden: false,
                rolleDetailUiFehler: false,
                rolleDetailUiFehlerObjekt: null,

                rolleMitteilungOptionen: null,
                rolleMitteilungOptionenLaden: false,
                rolleMitteilungOptionenFehler: false
            });
        }

        case actionsUi.AKTUELLEN_TAB_GESETZT: {
            const a = <actionsUi.AktuellenTabSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                tabUiSelektiert: a.tab
            });
        }

        default: {
            return state;
        }
    }


}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('FunktionsbereicheRollenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getFunktionsbereicheListeFilterString = createSelector(getPageState, (state: PageState) => state.funktionsbereicheListeFilterString);
// export const getFunktionsbereichListe = createSelector(getPageState, (state: PageState) => {
//     const funktionsbereichListe = [...state.funktionsbereichListe];
//     return funktionsbereichListe.sort( (a, b) => {
//         if(a.titel && b.titel) {
//             if (a.titel.toLowerCase() < b.titel.toLowerCase()) {
//                 return -1;
//             }
//             if (a.titel.toLowerCase() > b.titel.toLowerCase()) {
//                 return 1;
//             }
//         }
//         return 0;
//     });
// });

export const getFunktionsbereichListe = createSelector(getPageState, (state: PageState) => {
    return state.funktionsbereichListe
        .map((fb) => <ListInputItem>{
                    groupId: null,
                    groupTitle: null,
                    itemId: fb.funktionsbereich_id,
                    itemTitle: fb.titel,
                    item: fb,
                });
});


// export const getFunktionsbereichListe = createSelector(getPageState, getFunktionsbereicheListeFilterString, (state: PageState, filter: string) => {
//     return state.funktionsbereichListe.filter((item) => {
//                 return filter === '' || item.titel.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
//             })
//     .sort((a: Funktionsbereich, b: Funktionsbereich) => {
//         if (a.titel.toLowerCase() < b.titel.toLowerCase()) {
//             return -1;
//         }
//         if (a.titel.toLowerCase() > b.titel.toLowerCase()) {
//             return 1;
//         }
//         return 0;
//     });
// });


export const getFunktionsbereichListeUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichListeUiLaden);
export const getFunktionsbereichListeUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichListeUiFehler);
export const getFunktionsbereichListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichListeUiFehlerObjekt);
export const getFunktionsbereichListeUiSelektiert = createSelector(getPageState, (state: PageState) => state.funktionsbereichListeUiSelektiert);

export const getFunktionsbereichDetail = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetail);
export const getFunktionsbereichDetailUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiLaden);
export const getFunktionsbereichDetailUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiFehler);
export const getFunktionsbereichDetailUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiFehlerObjekt);

export const getFunktionsbereichAdminBenutzerListe = createSelector(getPageState, (state: PageState) => {
    const funktionsbereichAdminBenutzerListe = [...state.funktionsbereichAdminBenutzerListe];
    return funktionsbereichAdminBenutzerListe.map((item: FunktionsbereichAdminBenutzer) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.benutzer_id,
        itemTitle: item.benutzer_name,
        item: item
    });
});
export const getFunktionsbereichAdminBenutzerListeUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichAdminBenutzerListeUiLaden);
export const getFunktionsbereichAdminBenutzerListeUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichAdminBenutzerListeUiFehler);
export const getFunktionsbereichAdminBenutzerListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichAdminBenutzerListeUiFehlerObjekt);
export const getFunktionsbereichAdminBenutzerListeUiSelektiert = createSelector(getPageState, (state: PageState) => {
    return state.funktionsbereichAdminBenutzerListeUiSelektiert;
});

export const getFunktionsbereichFreigabeRolleListe = createSelector(getPageState, (state: PageState) => {
    const funktionsbereichFreigabeRolleListe = [...state.funktionsbereichFreigabeRolleListe];
    return funktionsbereichFreigabeRolleListe.map((item: FunktionsbereichFreigabeRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle_id,
        itemTitle: item.rolle_titel + ' (' + item.funktionsbereich.titel + ')',
        item: item
    });
});
export const getFunktionsbereichFreigabeRolleListeUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichFreigabeRolleListeUiLaden);
export const getFunktionsbereichFreigabeRolleListeUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichFreigabeRolleListeUiFehler);
export const getFunktionsbereichFreigabeRolleListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichFreigabeRolleListeUiFehlerObjekt);
export const getFunktionsbereichFreigabeRolleListeUiSelektiert = createSelector(getPageState, (state: PageState) => state.funktionsbereichFreigabeRolleListeUiSelektiert);

export const getFunktionsbereichAbteilungsLeitstand = createSelector(getPageState, (state: PageState) => state.funktionsbereichAbteilungsLeitstand);
export const getFunktionsbereichAbteilungsLeitstandUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichAbteilungsLeitstandUiLaden);
export const getFunktionsbereichAbteilungsLeitstandUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichAbteilungsLeitstandUiFehler);
export const getFunktionsbereichAbteilungsLeitstandUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichAbteilungsLeitstandUiFehlerObjekt);

export const getRolleListe = createSelector(getPageState, (state: PageState) => {
    const rolleListe = [...state.rolleListe];

    return rolleListe.map((item: Rolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle_id,
        itemTitle: item.titel,
        item: item
    });
});
export const getRolleListeUiLaden = createSelector(getPageState, (state: PageState) => state.rolleListeUiLaden);
export const getRolleListeUiFehler = createSelector(getPageState, (state: PageState) => state.rolleListeUiFehler);
export const getRolleListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleListeUiFehlerObjekt);
export const getRolleListeUiSelektiert = createSelector(getPageState, (state: PageState) => state.rolleListeUiSelektiert);

export const getRolleDetail = createSelector(getPageState, (state: PageState) => state.rolleDetail);
export const getRolleDetailUiLaden = createSelector(getPageState, (state: PageState) => state.rolleDetailUiLaden);
export const getRolleDetailUiFehler = createSelector(getPageState, (state: PageState) => state.rolleDetailUiFehler);
export const getRolleDetailUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleDetailUiFehlerObjekt);

export const getRolleMitteilungOptionen = createSelector(getPageState, (state: PageState) => state.rolleMitteilungOptionen);
export const getRolleMitteilungOptionenUiLaden = createSelector(getPageState, (state: PageState) => state.rolleMitteilungOptionenLaden);
export const getRolleMitteilungOptionenUiFehler = createSelector(getPageState, (state: PageState) => state.rolleMitteilungOptionenFehler);

export const getRolleZentralLeitstand = createSelector(getPageState, (state: PageState) => state.rolleZentralLeitstand);
export const getRolleZentralLeitstandUiLaden = createSelector(getPageState, (state: PageState) => state.rolleZentralLeitstandUiLaden);
export const getRolleZentralLeitstandUiFehler = createSelector(getPageState, (state: PageState) => state.rolleZentralLeitstandUiFehler);
export const getRolleZentralLeitstandUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleZentralLeitstandUiFehlerObjekt);

export const getRolleAbteilungsLeitstand = createSelector(getPageState, (state: PageState) => state.rolleAbteilungsLeitstand);
export const getRolleAbteilungsLeitstandUiLaden = createSelector(getPageState, (state: PageState) => state.rolleAbteilungsLeitstandUiLaden);
export const getRolleAbteilungsLeitstandUiFehler = createSelector(getPageState, (state: PageState) => state.rolleAbteilungsLeitstandUiFehler);
export const getRolleAbteilungsLeitstandUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleAbteilungsLeitstandUiFehlerObjekt);

export const getRolleBerechtigung = createSelector(getPageState, (state: PageState) => state.rolleBerechtigung);
export const getRolleBerechtigungUiLaden = createSelector(getPageState, (state: PageState) => state.rolleBerechtigungUiLaden);
export const getRolleBerechtigungUiFehler = createSelector(getPageState, (state: PageState) => state.rolleBerechtigungUiFehler);
export const getRolleBerechtigungUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleBerechtigungUiFehlerObjekt);

export const getRolleMitteilungsVorlagen = createSelector(getPageState, (state: PageState) => {
    const rolleMitteilungsVorlagen = [...state.rolleMitteilungsVorlagen];

    return rolleMitteilungsVorlagen.map((item: MitteilungsVorlage) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.mitteilungs_vorlage_id,
        itemTitle: item.titel,
        item: item
    });
});
export const getRolleMitteilungsVorlagenLaden = createSelector(getPageState, (state: PageState) => state.rolleMitteilungsVorlagenLaden);
export const getRolleMitteilungsVorlagenFehler = createSelector(getPageState, (state: PageState) => state.rolleMitteilungsVorlagenFehler);
export const getSelectedRolleMitteilungsVorlage = createSelector(getPageState, (state: PageState) => state.selectedRolleMitteilungsVorlage);

export const getVorlagenEmfpaenger = createSelector(getPageState, (state: PageState) => {
    if (state.rolleMitteilungsVorlageDetail === null || state.rolleMitteilungsVorlageDetail === undefined) {
        return [];
    }

    const vorlagenEmpfaenger = [...state.rolleMitteilungsVorlageDetail.empfaenger_rolle_liste];

    return vorlagenEmpfaenger.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel,
        item: item
    });
});

export const getVorlagenTypen = createSelector(getPageState, (state: PageState) => {
    if (state.rolleMitteilungsVorlageDetail === null || state.rolleMitteilungsVorlageDetail === undefined) {
        return [];
    }

    const vorlagenTypen = [...state.rolleMitteilungsVorlageDetail.veranstaltungstyp_liste];

    return vorlagenTypen.map((item: VeranstaltungsTyp) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.veranstaltungstyp_id,
        itemTitle: item.bezeichnung,
        item: item
    });
});

export const getMitteilungsVorlageDetail = createSelector(getPageState, (state: PageState) => state.rolleMitteilungsVorlageDetail);
export const getMitteilungsVorlageDetailLaden = createSelector(getPageState, (state: PageState) => state.rolleMitteilungsVorlageDetailLaden);
export const getMitteilungsVorlageDetailFehler = createSelector(getPageState, (state: PageState) => state.rolleMitteilungsVorlageDetailFehler);

export const getSelectedVorlageEmpfaenger = createSelector(getPageState, (state: PageState) => state.selectedRolleMitteilungsVorlageEmpfaenger);
export const getSelectedVorlageTypen = createSelector(getPageState, (state: PageState) => state.selectedRolleMitteilungsVorlageTypen);

export const getRolleEinlasskontrolle = createSelector(getPageState, (state: PageState) => state.einlasskontrolleRolle);
export const getRolleEinlasskontrolleLaden = createSelector(getPageState, (state: PageState) => state.einlasskontrolleRolleLaden);
export const getRolleEinlasskontrolleFehler = createSelector(getPageState, (state: PageState) => state.einlasskontrolleRolleFehler);

export const getRolleDisplaysteuerung = createSelector(getPageState, (state: PageState) => state.displaysteuerungRolle);
export const getRolleDisplaysteuerungLaden = createSelector(getPageState, (state: PageState) => state.displaysteuerungRolleLaden);
export const getRolleDisplaysteuerungFehler = createSelector(getPageState, (state: PageState) => state.displaysteuerungRolleFehler);

export const getRolleQsChecks = createSelector(getPageState, (state: PageState) => state.qsChecksRolle);
export const getRolleQsChecksLaden = createSelector(getPageState, (state: PageState) => state.qsChecksRolleLaden);
export const getRolleQsChecksFehler = createSelector(getPageState, (state: PageState) => state.qsChecksRolleFehler);

export const getBVRolleBerechtigungen = createSelector(getPageState, (state: PageState) => state.bvRolleBerechtigungen);
export const getBVRolleBerechtigungenLaden = createSelector(getPageState, (state: PageState) => state.bvRolleBerechtigungenLaden);
export const getBVRolleBerechtigungenFehler = createSelector(getPageState, (state: PageState) => state.bvRolleBerechtigungenFehler);

export const getTabUiSelektiert = createSelector(getPageState, (state: PageState) => state.tabUiSelektiert);

